export type { Modifier, GameMeta } from "./gameMeta.js";

/**
 * @module GameIndex
 * @description Registry of games available in the system, with metadata merged from each game's shelf/meta.ts.
 * @default gameIndex
 * @exports gameIndex
 * @exports reverseIndex
 */

import type { GameMeta } from "./gameMeta.js";
import { meta as circleRiderMeta } from "../shelf/circleRider/meta.js";
import { meta as hueHuntMeta } from "../shelf/hueHunt/meta.js";
import { meta as tileTangleMeta } from "../shelf/tileTangle/meta.js";
import { meta as mirrorMirrorMeta } from "../shelf/mirrorMirror/meta.js";
import { meta as traceRaceMeta } from "../shelf/traceRace/meta.js";
import { meta as auctionHouseMeta } from "../shelf/auctionHouse/meta.js";
import { meta as dotDashMeta } from "../shelf/dotDash/meta.js";
import { meta as colorCodeMeta } from "../shelf/colorCode/meta.js";
import { meta as turfWarMeta }  from "../shelf/turfWar/meta.js";

type GameIndexEntry = { id: string; slug: string; active: number } & GameMeta;

var gameIndex: Record<string, GameIndexEntry> = {
	circleRider:         { id: "ccr1Fw9U",    slug: "circleRider",         active: 1, ...circleRiderMeta },
	hueHunt:             { id: "HueHnt2025",  slug: "hueHunt",             active: 1, ...hueHuntMeta },
	tileTangle:          { id: "kPn1Fw9U",    slug: "tileTangle",          active: 1, ...tileTangleMeta },
	mirrorMirror:        { id: "MrrMrr2025",  slug: "mirrorMirror",        active: 1, ...mirrorMirrorMeta },
	traceRace:           { id: "TrcRc2025",   slug: "traceRace",           active: 1, ...traceRaceMeta },
	auctionHouse:        { id: "ActnHs2025",  slug: "auctionHouse",        active: 1, ...auctionHouseMeta },
	dotDash:             { id: "DtDsh2025",   slug: "dotDash",             active: 1, ...dotDashMeta },
	colorCode:           { id: "ClrCd2026",   slug: "colorCode",           active: 1, ...colorCodeMeta },
	turfWar:             { id: "TrfWr2026",   slug: "turfWar",             active: 1, ...turfWarMeta },
};

var reverseIndex = Object.fromEntries(
	Object.entries(gameIndex).map(([key, value]) => [value.id, key]),
);

export { reverseIndex, gameIndex };

export default gameIndex;
